export default function NFTList({ nfts }) {
  return (
    <div className='grid sm:grid-cols-3 gap-16 pb-16'>
      {nfts.map(slug => (
        <div key={slug}><img className="max-w-full mx-auto" src={`images/nfts/${slug}.png`} alt="" width={314} height={525} /></div>
      ))}
    </div>
  )
}
